/** @format */

const phoneCondition = (number, regularExpressions = []) =>
  /^\+\d{5,}$/.test(number) ||
  regularExpressions.some((regex) => regex.test(number));

export { phoneCondition };
